import { useState, useContext } from "react";
import { useLoaderData, useParams } from "react-router-dom";
import DataContext from "../../../context/DataContext";
import { ClientDetailContext } from "../../cm/Dashboard/FullPages/ClientDetail/context/ClientDetailContext";
import ProviderDetailv2 from "../../global/ProviderDetailModal/ProviderDetailv2";
import EditApptv2 from "../../cm/Dashboard/FullPages/ClientDetail/ProvApptDetails/EditApptv2";
import DocumentUpload from "../../cm/Dashboard/FullPages/ClientDetail/DocumentManager/DocumentUpload";
import DeleteApptv2 from "../../cm/Dashboard/FullPages/ClientDetail/ProvApptDetails/DeleteApptv2";
import ModalShell from "../../global/ModalShell";
import { useDebouncedEffect } from "../../../hooks/useDebounceEffect";
import useService from "../../../hooks/useService";
import AppointmentsTable from "./AppointmentsTable";

export default function Appointments() {
  const [docTrigger, setDocTrigger] = useState(false);
  const [provider, setProvider] = useState(null);
  const [providerDetailDisplay, setProviderDetailDisplay] = useState(false);
  const [selectedAppt, setSelectedAppt] = useState();
  const [openDeleteAppt, setOpenDeleteAppt] = useState(false);
  const [openEditAppt, setOpenEditAppt] = useState(false);
  const { setSelectedAppointment, setIsLaunchedFromAppointmentsTab } =
    useContext(ClientDetailContext);
  const [loading, setLoading] = useState(false);
  const [appointments, setAppointments] = useState([]);
  const [uploadDocument, setUploadDocument] = useState(false);
  const [proCliTrigger, setProCliTrigger] = useState(false);
  const [apptSearch, setApptSearch] = useState("");
  const [showMoreApptsVisible, setShowMoreApptsVisible] = useState(false);
  const [apptResLimit, setApptResLimit] = useState(20);

  const { activeBills, trigger } = useContext(DataContext);

  const appointmentsService = useService("repositories/appointment-repository");

  const params = useParams();

  const { userRoles } = useContext(DataContext);

  const permissionAppointments = userRoles.permissions.includes(
    "provider.view_appointment",
  );

  const { _case, _caseId } = useLoaderData();

  useDebouncedEffect(
    () => {
      if (params && permissionAppointments && _case) {
        setLoading(true);
        let searchQuery = !apptSearch ? "" : apptSearch;
        const fetchAppointments = async () => {
          try {
            const results = await appointmentsService.query({
              client: _caseId,
              limit: apptResLimit,
              ordering: "-scheduled",
              search: searchQuery || undefined,
            });
            const totalAppointments = await appointmentsService.getTotalCount();
            if (totalAppointments <= apptResLimit) {
              setShowMoreApptsVisible(false);
            } else {
              setShowMoreApptsVisible(true);
            }

            setAppointments(results);
            setLoading(false);
          } catch (error) {
            console.error("Error fetching appointments:", error);
            setLoading(false);
          }
        };
        fetchAppointments();
      }
    },
    [
      params,
      appointmentsService,
      apptSearch,
      proCliTrigger,
      trigger,
      apptResLimit,
    ],
    250,
  );

  function handleProviderApptEdit(appt) {
    setSelectedAppt(appt);
    setOpenEditAppt(!openEditAppt);
  }

  const handleUploadDocument = (appt) => {
    setSelectedAppointment(appt);
    setIsLaunchedFromAppointmentsTab(true);
    setUploadDocument(true);
  };

  function handleApptDelete(appt) {
    setSelectedAppt(appt);
    setOpenDeleteAppt(!openDeleteAppt);
  }

  return (
    <>
      <AppointmentsTable
        caseInfo={_case}
        apptSearch={apptSearch}
        setApptSearch={setApptSearch}
        loading={loading}
        appointments={appointments}
        activeBills={activeBills}
        handleApptDelete={handleApptDelete}
        handleProviderApptEdit={handleProviderApptEdit}
        setProvider={setProvider}
        setProviderDetailDisplay={setProviderDetailDisplay}
        handleUploadDocument={handleUploadDocument}
        showMoreApptsVisible={showMoreApptsVisible}
        apptResLimit={apptResLimit}
        setApptResLimit={setApptResLimit}
        proCliTrigger={proCliTrigger}
        setProCliTrigger={setProCliTrigger}
      />
      {providerDetailDisplay && (
        <ProviderDetailv2
          providerDetail={provider}
          open={providerDetailDisplay}
          setOpen={setProviderDetailDisplay}
        />
      )}
      <EditApptv2
        open={openEditAppt}
        selectedAppt={selectedAppt}
        onClose={() => setOpenEditAppt(false)}
        proCliTrigger={proCliTrigger}
        setProCliTrigger={setProCliTrigger}
      />
      <DocumentUpload
        closeUploadModal={() => setUploadDocument(false)}
        casePk={!_case ? "" : _case.id}
        clientId={_case?.client?.id}
        uploadDocument={uploadDocument}
        setUploadDocument={setUploadDocument}
        docTrigger={docTrigger}
        setDocTrigger={setDocTrigger}
        caseInfo={_case}
      />
      <ModalShell
        open={openDeleteAppt}
        setOpen={setOpenDeleteAppt}
        color={"rgb(220 38 38)"}
        title={"Delete Appointment"}
      >
        <DeleteApptv2
          selectedAppt={selectedAppt}
          openDeleteAppt={openDeleteAppt}
          setOpenDeleteAppt={setOpenDeleteAppt}
          proCliTrigger={proCliTrigger}
          setProCliTrigger={setProCliTrigger}
        />
      </ModalShell>
    </>
  );
}
